import React from "react";
import backgroundLandingImg from "../../../../assets/background-landing.png"; // ✅ no hyphen

const PricingNavHeader = () => {
  return (
    // <section className="w-full bg-[#6E3FC6] pt-14 pb-20 px-6 text-center font-[Lexend] mt-8 sm:mt-5 md:mt-10">
    // <section
    //   className="w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat py-20 md:py-24 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 relative"
    //   style={{
    //     backgroundImage: `url(${backgroundLandingImg})`, // ✅ use the imported image
    //     backgroundBlendMode: "overlay", // softly merges image & color
    //   }}
    // >
    //   <h2 className="text-white font-bold text-[33px] sm:text-[40px] md:text-[40px] leading-[90%] lowercase -mt-2">
    //     <br />
    //     <span >choose a package that fits your business</span>
    //   </h2>
    //   <p className="mt-6 font-[Lexend] font-normal text-[20px] leading-[30px] tracking-normal text-[#E0DFFF] text-center lowercase">
    //     free no risk 30 day trial. cancel anytime
    //   </p>
    // </section>

    <section
      className="relative w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat py-20 md:py-20 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 min-h-[200px]"
      style={{ backgroundImage: `url(${backgroundLandingImg})` }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-[#6E3FC6]/65 pointer-events-none"></div>

      {/* ✅ Content Wrapper with extra top padding */}
      <div className="relative max-w-[1000px] mx-auto pt-[30px]">
        <h1 className="font-semibold text-[26px] sm:text-[24px] md:text-[42px] lg:text-[48px] lowercase text-white leading-[50px] mb-1 leading-[32px] sm:leading-[25px] md:leading-[50px]">
          <span >choose a package that fits your business</span>
        </h1>
        <p className="mt-4 text-[#e0dfff] text-base md:text-lg font-normal max-w-[600px] mx-auto">
          free no risk 30 day trial. cancel anytime
        </p>
      </div>
    </section>
  );
};

export default PricingNavHeader;